import React from 'react';

const Header = () => {
    return (
        <div className="container">
            <h1 className="text-center">Recipe Search App</h1>
        </div>
    )
}

export default Header